import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SET_PAYMENT_MUTATION = gql`
  mutation Post(
    $paymentFetchedFromProviderId: String!
    $email: String!
    $productSlugName: String!
  ) {
    setManualPayment(
      paymentFetchedFromProviderId: $paymentFetchedFromProviderId
      email: $email
      productSlugName: $productSlugName
    ) {
      result
      error
    }
  }
`;

const setManualPayment = async (variables) => {
  try {
    const result = await client
      .mutate({
        mutation: SET_PAYMENT_MUTATION,
        variables,
        fetchPolicy: 'no-cache',
      })
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { setManualPayment: setManualPaymentValidationData },
    } = result;

    if (setManualPaymentValidationData) {
      return setManualPaymentValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: setManualPaymentValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: setManualPayment Error: ${error}`);
    return null;
  }
};

export default setManualPayment;
